<template>
    <div>
        111
    </div>
</template>

<script>
    export default {
        name: "details"
    }
</script>

<style scoped>

</style>
